// Pairwise ribbon intersections: the layer between the layout and Overlap, Number of Crossings, and Crossing Angle.

// Calls callback(i, j) for every ribbon pair i < j of the same band, in the order of the plain double loop.
// Ribbons of different bands share at most a piece of an axis line and cannot overlap.
export function forEachPair(ribbons, callback) {
    for (let i = 0; i < ribbons.length; i++) {
        for (let j = i + 1; j < ribbons.length; j++) {
            if (ribbons[i].band === ribbons[j].band) callback(i, j);
        }
    }
}

function signedArea(polygon) {
    let area = 0;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        area += polygon[j][0] * polygon[i][1] - polygon[i][0] * polygon[j][1];
    }
    return area / 2;
}

// Sutherland-Hodgman clipping; exact for two convex polygons. Returns the intersection polygon (may be empty).
export function clipConvex(subject, clip) {
    const orientation = signedArea(clip) < 0 ? -1 : 1;
    let output = subject;
    for (let i = 0; i < clip.length && output.length > 0; i++) {
        const a = clip[i];
        const b = clip[(i + 1) % clip.length];
        const side = p => orientation * ((b[0] - a[0]) * (p[1] - a[1]) - (b[1] - a[1]) * (p[0] - a[0]));
        const input = output;
        output = [];
        for (let k = 0; k < input.length; k++) {
            const current = input[k];
            const previous = input[(k + input.length - 1) % input.length];
            const sideCurrent = side(current);
            const sidePrevious = side(previous);
            if ((sideCurrent >= 0) !== (sidePrevious >= 0)) {
                const t = sidePrevious / (sidePrevious - sideCurrent);
                output.push([previous[0] + t * (current[0] - previous[0]), previous[1] + t * (current[1] - previous[1])]);
            }
            if (sideCurrent >= 0) output.push(current);
        }
    }
    return output;
}

export function ribbonPolygon(ribbon) {
    return [ribbon.tl, ribbon.bl, ribbon.br, ribbon.tr];
}

// Area of the intersection of two ribbons (parallelograms, hence convex), in px^2.
export function overlapArea(ribbonA, ribbonB) {
    // Cheap rejection: the horizontal extents do not overlap.
    const minA = Math.min(ribbonA.tl[0], ribbonA.bl[0]), maxA = Math.max(ribbonA.tr[0], ribbonA.br[0]);
    const minB = Math.min(ribbonB.tl[0], ribbonB.bl[0]), maxB = Math.max(ribbonB.tr[0], ribbonB.br[0]);
    if (maxA <= minB || maxB <= minA) return 0;
    return Math.abs(signedArea(clipConvex(ribbonPolygon(ribbonA), ribbonPolygon(ribbonB))));
}
